module.exports = __webpack_public_path__ + "media/images/401playlogo--693e80166deda1bc8c3d8a98b8480bee.png";